import { Check, X } from "lucide-react";
import { Section, ChromeHeading, Card } from "../funnel";

const FOR = [
  "Business owners with revenue who've been denied or under-funded",
  "9-to-5 professionals building a business on the side who need capital to grow it",
  "Tax pros, realtors and other service pros who want to offer credit and funding to clients they already have",
];
const EVEN_IF = [
  "your credit isn't where you want it yet",
  "you've never applied for business credit",
  "you've been denied before and never got a straight answer",
  "you've never borrowed for your business, because you've always paid cash",
];
const NOT_FOR = [
  "Anyone looking for a get-rich-quick hack. This is a real process and it takes work.",
  "Anyone who needs emergency money in the next two weeks",
  "Anyone planning to borrow without a plan to pay it back",
];

const List = ({ items, icon: Icon, tone }) => (
  <ul className="mt-5 space-y-4">
    {items.map((t) => (
      <li key={t} className="flex items-start gap-3 text-[15px] leading-relaxed text-[#e4dccb]">
        <span className={`mt-0.5 grid h-6 w-6 shrink-0 place-items-center rounded-full border ${tone}`}><Icon className="h-3.5 w-3.5" /></span>
        <span>{t}</span>
      </li>
    ))}
  </ul>
);

const Label = ({ children }) => <p className="eyebrow">{children}</p>;

export const WhoFor = () => (
  <Section data-testid="who-for-section">
    <ChromeHeading className="text-4xl sm:text-5xl lg:text-6xl">Who this is for</ChromeHeading>
    <div className="mt-12 grid gap-5 lg:grid-cols-2">
      <Card className="p-7 sm:p-9" data-testid="who-for-card">
        <Label>For</Label>
        <List items={FOR} icon={Check} tone="border-[rgba(232,184,74,0.6)] text-[var(--gold)]" />
        <div className="my-8 hairline" aria-hidden="true" />
        <Label>Even if…</Label>
        <List items={EVEN_IF} icon={Check} tone="border-[rgba(232,184,74,0.6)] text-[var(--gold)]" />
      </Card>
      <Card className="self-start p-7 sm:p-9" data-testid="not-for-card">
        <Label>NOT for</Label>
        <List items={NOT_FOR} icon={X} tone="border-white/25 text-[#a59f93]" />
      </Card>
    </div>
  </Section>
);
